import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styles from "./dropdown.module.css";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import useTranslation from "next-translate/useTranslation";

var DropdownGetLevels = function DropdownGetLevels(_ref) {
  var classes = _ref.classes,
      defaultSelected = _ref.defaultSelected,
      selectedTopic = _ref.selectedTopic,
      data = _ref.data,
      setSelectedTopic = _ref.setSelectedTopic,
      selectedLesson = _ref.selectedLesson,
      setShow = _ref.setShow,
      setError = _ref.setError;

  var _useState = useState(false),
      dropdownOpen = _useState[0],
      setDropdownOpen = _useState[1];

  var toggle = function toggle() {
    var Username = localStorage.getItem('Username');
    var token = localStorage.getItem('token');

    if (Username && token) {
      setDropdownOpen(function (prevState) {
        return !prevState;
      });
    } else {
      setError(["login", false]);
      setShow(true);
    }
  };

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  useEffect(function () {
    setSelectedTopic(isRTL ? defaultSelected.fa : defaultSelected.en);
  }, []);

  var handleSelect = function handleSelect(selectedItem) {
    // setLoading(true)
    setSelectedTopic(selectedItem); // setSelectedItem(selectedItem.title)
    // setValidated(prevState=>({...prevState, level: true}))
  };

  return /*#__PURE__*/_jsx("div", {
    className: styles.wrapper,
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(Dropdown, {
        className: "".concat(styles.menuItem, " ").concat(classes.bg),
        isOpen: dropdownOpen,
        toggle: toggle,
        children: [/*#__PURE__*/_jsx("div", {
          className: classes.arrow
        }), /*#__PURE__*/_jsx(DropdownToggle, {
          caret: true,
          children: selectedTopic !== null && selectedTopic !== void 0 && selectedTopic.title ? selectedTopic.title : isRTL ? defaultSelected.fa : defaultSelected.en
        }), /*#__PURE__*/_jsx(DropdownMenu, {
          children: data && data.length > 0 && selectedLesson && selectedLesson.LessonId ? data.map(function (item, index) {
            return /*#__PURE__*/_jsx(DropdownItem, {
              style: {
                direction: 'ltr'
              },
              onClick: function onClick() {
                return handleSelect({
                  title: item.title,
                  id: index + 1
                });
              },
              children: item.title
            });
          }) : /*#__PURE__*/_jsx(DropdownItem, {
            children: isRTL ? 'یک درس انتخاب کنید' : 'Choose a Lesson'
          })
        })]
      })
    })
  });
};

export default DropdownGetLevels;